<template>
  <b-modal
    id="modalCalculationProductionCompensation"
    v-model="localActive"
    centered
    hide-footer
    hide-header
    @show="onShowModal"
    @close="localActive = false"
  >
    <div class="m-compensation">
      <svg
        class="m-compensation-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="localActive = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-compensation-title">Причины надбавок за короткую смену</div>

      <div
        class="m-compensation-form"
        :class="{ 'm-compensation-form-required': compensationErrorMessage.length > 0 || priceErrorMessage.length > 0 }"
      >
        <c-input
          v-model="compensationLocalValue"
          class="m-compensation-form-compensation"
          :class="{ 'm-compensation-form-compensation-required': compensationErrorMessage.length }"
          type="select"
          label="Компенсация"
          placeholder="Компенсация"
          :required="compensationErrorMessage"
          :required-condition="compensationErrorMessage.length > 0"
          :items="compensationLocalItems"
          :searchable="true"
        />
        <c-input
          v-model="priceLocalValue"
          class="m-compensation-form-price"
          label="Сумма, ฿"
          placeholder="0"
          type="price-number"
          :required="priceErrorMessage"
          :input-text-condition="priceErrorMessage"
        />
      </div>

      <div class="m-compensation-actions">
        <c-button size="large" class="m-compensation-actions-cancel" label="Отменить" @click="closeModal" />
        <c-button class="m-compensation-actions-save" label="Сохранить" color="blue" size="large" @click="submitForm" />
      </div>
    </div>
  </b-modal>
</template>

<script>
import Input from "@/components/controls2/Input";
import Button from "@/components/controls/button";

export default {
  name: "m-calculation-production-compensation",

  components: {
    "c-input": Input,
    "c-button": Button,
  },

  props: ["active", "data", "calcData", "record"],

  data() {
    return {
      localActive: false,
      compensationLocalValue: null,
      compensationErrorMessage: "",
      compensationLocalItems: [
        { label: "Смена 6 или менее часов", value: 1 },
        { label: "Отпустили в связи с производственной необходимостью", value: 2 },
        { label: "Сотрудник отпросился", value: 3 },
        { label: "Замена сотрудника", value: 4 },
        { label: "Вызвали с выходного дня", value: 5 },
      ],
      priceLocalValue: "",
      priceErrorMessage: "",
      submitAttempt: false,
    };
  },

  watch: {
    compensationLocalValue(value) {
      if (value && value.value && value.value in this.calcData.listReasonSurchargeSum) {
        this.priceLocalValue=this.calcData.listReasonSurchargeSum[value.value];
      }
      if (this.submitAttempt) {
        if (value === null) {
          this.compensationErrorMessage = "Обязательное поле";
        } else {
          this.compensationErrorMessage = "";
        }
      }
    },
    priceLocalValue(value) {
      if (this.submitAttempt) {
        if (value === 0 || value === "") {
          this.priceErrorMessage = "Обязательное поле";
        } else {
          this.priceErrorMessage = "";
        }
      }
    },
    localActive(value) {
      if (!value) {
        this.$emit("close");
        setTimeout(() => {
          this.priceLocalValue = 0;
          this.compensationLocalValue = null;
        }, 200);
      }
    },
    active(value) {
      this.localActive = value;
    },
  },

  methods: {
    onShowModal() {
      this.compensationLocalItems=[];
     // console.log(this.calcData.listReasonSurchargeSelect);
      for (var id in this.calcData.listReasonSurchargeSelect) {
        let name = this.calcData.listReasonSurchargeSelect[id];
        this.compensationLocalItems.push({label:name, value:id});
      };
      this.priceLocalValue = this.record.compensation.value ? this.record.compensation.value : 100;
      if (this.record.compensation.id) {
        this.compensationLocalValue = this.compensationLocalItems.find((f)=>f.value==this.record.compensation.id);
      }
    },
    closeModal() {
      this.localActive = false;
    },
    submitForm() {
      let isValidForm = true;

      if (this.compensationLocalValue === null) {
        this.compensationErrorMessage = "Обязательное поле";
        isValidForm = false;
        this.submitAttempt = true;
      }

      if (this.priceLocalValue === "") {
        this.priceErrorMessage = "Обязательное поле";
        isValidForm = false;
        this.submitAttempt = true;
      }

      if (isValidForm) {
        this.closeModal();
        this.$emit("sendCompensationValue", {value:this.priceLocalValue, id:this.compensationLocalValue.value, record:this.record});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.m-compensation {
  &-close {
    cursor: pointer;
    position: absolute;
    top: 14px;
    right: 12px;
  }

  &-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;
  }

  &-form {
    margin-top: 26px;
    display: flex;
    justify-content: space-between;

    &-required {
      padding-bottom: 22px;

      @media screen and (max-width: 700px) {
        padding-bottom: 0;
      }
    }

    @media screen and (max-width: 700px) {
      flex-direction: column;
    }

    &-compensation {
      width: 75%;

      &-required {
        @media screen and (max-width: 700px) {
          padding-bottom: 22px;
        }
      }

      @media screen and (max-width: 700px) {
        width: 100%;
      }
    }

    &-price {
      width: 20%;

      @media screen and (max-width: 700px) {
        margin-top: 26px;
        width: 50%;
      }
    }
  }

  &-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 40px;

    @media screen and (max-width: 700px) {
      width: 100%;
      box-shadow: 0px 0px 15px rgba(8, 20, 45, 0.3);
      position: fixed;
      bottom: 0;
      left: 0;
    }

    &-cancel {
      @media screen and (max-width: 700px) {
        width: 50%;
      }

      ::v-deep & .c-button__wrapper {
        height: 38px !important;

        @media screen and (max-width: 700px) {
          display: flex;
          justify-content: center;
          width: 100%;
          border-radius: 0;
        }
      }
    }

    &-save {
      margin-left: 10px;

      @media screen and (max-width: 700px) {
        margin-left: 0;
        width: 50%;
      }

      ::v-deep & .c-button__wrapper {
        height: 38px !important;

        @media screen and (max-width: 700px) {
          display: flex;
          justify-content: center;
          width: 100%;
          border-radius: 0;
        }
      }
    }
  }
}
</style>
